// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primaryColor: #012643;
  --primaryColor50: #EBF3FE;
  --primaryColor300: #7CABF9;
  --primaryColor100: #C2D8FC;
  --primaryColor500: #3B82F6;
  --primaryColor32: #c0d7fc;
  --primaryColor600: #3676E0;
  --primaryColor700: #2A5CAF;
  --primaryColor900:  #098D94;
  --secondColor: #FFFFFF;
  --thirdColor: #D9D9D9;
  --sematicColor:#1677FF;
  --sematicSuccessColor: #389E0D;
  --sematicSuccessColor50: #EAF6F0;
  --sematicSuccessColor300: #75C09A;
  --sematicSuccessColor500: #31A168;
  --sematicPrimaryColor:#002C8C;
  --sematicErrorColor: #D9363E;
  --sematicErrorColor500: #FF5454;
  --sematicWarningColor50: #FEF8E7;
  --sematicWarningColor: #F5B40B;
  --sematicWarningColorCus: #f1af07;
  --sematicErrorColor600:  #F77138;
  --sematicInfoColor: #0958D9;
  --cyanColor: #006D75;
  --textBlack: #000000;
  --textBlack16: #00000029;
  --textBlack2: #F5F5F5;
  --textBlack4: #0000000A;
  --textBlack3:#ebebeb;
  --textBlack10:#e2e2e2;
  --textBlack2: #00000005;
  --textBlack8: #F0F0F0;
  --textBlack12: #0000001F;
  --textDescriptionRGB:rgba(137, 137, 137, 1);
  --textBlack56: #707070;
  --textBlack100:#012643;
  --textBlack24: #0000003D;
  --textBlack1E:#1E1E1E;
  --textWhite: #FFFFFF;
  --textWhite12:#FFFFFF1F;
  --textGray: #898989;
  --textGray700: #374151;
  --textGray500: #6b7280;
  --textGray50: rgba(137, 137, 137, 0.5);
  --bgWhite50: #FFFFFF50;
  --bgWhite80: #FFFFFF80;
  --bgWhite90: #FFFFFF90;
  --textWhite1:#D6DADD;
  --bgGrey: #F4F5F7;
  --textOpacity_8: rgba(32, 34, 49, 0.08);
  --greyTextColor: #585858;
  --bgGreyEy: #F4F5F7;
  --bgGreyColor: #EDEDED;
  --bgBlackOpacity : #0000000A;
  --bgBlackOpacity4 : #F5F6F7;
  --bgBlackOpacity5: #00000005;
  --bgBlackOpacity10: #fafafa;
  --bgRed50: #FFEEEE;
  --bgGreyColor1:#bbbbbb;
  --bgGreyColor2:#f4f5f7;
  --bgGreyColor02:#FAFAFB;
  --bgGreyColor3:#eaebed;
  --bgGreyColor4:#00192C0A;
  --bgGreyColor5:#fbfbfb;
  --bgGreyColor6:#f9fafa;
  --bgGreyColor7:#f2f2f2;
  --bgGreyColor400:#B1B1B1;
  --bgBlack24: #BEBEBE;
  --opacityTextColor: #00192C;
  --opacityText100:#202231;
  --opacityText56:#2022318F;
  --textWhite8: #FFFFFF14;
  --textBlack80Rgba: rgba(0, 0, 0, 0.8);
  --textWhite56: #FFFFFF8F;
  --textBlack56:#0000008F;
  --textBlack56Rgba: rgba(0, 0, 0, 0.56);
  --textBlack8: #00000014;
  --hoverColor: #012643CC;
  --colorRed:#FF4D4F;
  --colorRed1:#FF7875;
  --blueColor1:#0B82DC;
  --borderColor: #EBEBEB;
  --dataColor: #2EBEAA;
  --highlightColor: #ffc069;
  --indigoColor500: #3F51B5;
  --tealColor700: #218779;
  --textOpacity4: #f6f6f7;
  --keyColor1: rgba(1, 38, 67, 0.8);
  --keyColor2: rgba(4, 70, 122, 1);
  --keyColor3: rgba(1, 38, 67, 0.56);
  --colorPink: #E967CA;
  --colorViolet: #7A66C9;
  --colorBlueTk:#0360A9;
  --colorBrand:#04B3D4;
  --gradientPinkViolet: linear-gradient(to right, var(--textBlack100), var(--colorBlueTk));
}
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin-bottom: 0 !important;
}
.scrollbar-hide {
  scrollbar-width: none; 
  -ms-overflow-style: none;  
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/App.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,2CAA2C;EAC3C,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,sCAAsC;EACtC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,uCAAuC;EACvC,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,qCAAqC;EACrC,wBAAwB;EACxB,uBAAuB;EACvB,sCAAsC;EACtC,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,iCAAiC;EACjC,gCAAgC;EAChC,kCAAkC;EAClC,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,wFAAwF;AAC1F;AACA;;;;;;;EAOE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf","sourcesContent":[":root {\n  --primaryColor: #012643;\n  --primaryColor50: #EBF3FE;\n  --primaryColor300: #7CABF9;\n  --primaryColor100: #C2D8FC;\n  --primaryColor500: #3B82F6;\n  --primaryColor32: #c0d7fc;\n  --primaryColor600: #3676E0;\n  --primaryColor700: #2A5CAF;\n  --primaryColor900:  #098D94;\n  --secondColor: #FFFFFF;\n  --thirdColor: #D9D9D9;\n  --sematicColor:#1677FF;\n  --sematicSuccessColor: #389E0D;\n  --sematicSuccessColor50: #EAF6F0;\n  --sematicSuccessColor300: #75C09A;\n  --sematicSuccessColor500: #31A168;\n  --sematicPrimaryColor:#002C8C;\n  --sematicErrorColor: #D9363E;\n  --sematicErrorColor500: #FF5454;\n  --sematicWarningColor50: #FEF8E7;\n  --sematicWarningColor: #F5B40B;\n  --sematicWarningColorCus: #f1af07;\n  --sematicErrorColor600:  #F77138;\n  --sematicInfoColor: #0958D9;\n  --cyanColor: #006D75;\n  --textBlack: #000000;\n  --textBlack16: #00000029;\n  --textBlack2: #F5F5F5;\n  --textBlack4: #0000000A;\n  --textBlack3:#ebebeb;\n  --textBlack10:#e2e2e2;\n  --textBlack2: #00000005;\n  --textBlack8: #F0F0F0;\n  --textBlack12: #0000001F;\n  --textDescriptionRGB:rgba(137, 137, 137, 1);\n  --textBlack56: #707070;\n  --textBlack100:#012643;\n  --textBlack24: #0000003D;\n  --textBlack1E:#1E1E1E;\n  --textWhite: #FFFFFF;\n  --textWhite12:#FFFFFF1F;\n  --textGray: #898989;\n  --textGray700: #374151;\n  --textGray500: #6b7280;\n  --textGray50: rgba(137, 137, 137, 0.5);\n  --bgWhite50: #FFFFFF50;\n  --bgWhite80: #FFFFFF80;\n  --bgWhite90: #FFFFFF90;\n  --textWhite1:#D6DADD;\n  --bgGrey: #F4F5F7;\n  --textOpacity_8: rgba(32, 34, 49, 0.08);\n  --greyTextColor: #585858;\n  --bgGreyEy: #F4F5F7;\n  --bgGreyColor: #EDEDED;\n  --bgBlackOpacity : #0000000A;\n  --bgBlackOpacity4 : #F5F6F7;\n  --bgBlackOpacity5: #00000005;\n  --bgBlackOpacity10: #fafafa;\n  --bgRed50: #FFEEEE;\n  --bgGreyColor1:#bbbbbb;\n  --bgGreyColor2:#f4f5f7;\n  --bgGreyColor02:#FAFAFB;\n  --bgGreyColor3:#eaebed;\n  --bgGreyColor4:#00192C0A;\n  --bgGreyColor5:#fbfbfb;\n  --bgGreyColor6:#f9fafa;\n  --bgGreyColor7:#f2f2f2;\n  --bgGreyColor400:#B1B1B1;\n  --bgBlack24: #BEBEBE;\n  --opacityTextColor: #00192C;\n  --opacityText100:#202231;\n  --opacityText56:#2022318F;\n  --textWhite8: #FFFFFF14;\n  --textBlack80Rgba: rgba(0, 0, 0, 0.8);\n  --textWhite56: #FFFFFF8F;\n  --textBlack56:#0000008F;\n  --textBlack56Rgba: rgba(0, 0, 0, 0.56);\n  --textBlack8: #00000014;\n  --hoverColor: #012643CC;\n  --colorRed:#FF4D4F;\n  --colorRed1:#FF7875;\n  --blueColor1:#0B82DC;\n  --borderColor: #EBEBEB;\n  --dataColor: #2EBEAA;\n  --highlightColor: #ffc069;\n  --indigoColor500: #3F51B5;\n  --tealColor700: #218779;\n  --textOpacity4: #f6f6f7;\n  --keyColor1: rgba(1, 38, 67, 0.8);\n  --keyColor2: rgba(4, 70, 122, 1);\n  --keyColor3: rgba(1, 38, 67, 0.56);\n  --colorPink: #E967CA;\n  --colorViolet: #7A66C9;\n  --colorBlueTk:#0360A9;\n  --colorBrand:#04B3D4;\n  --gradientPinkViolet: linear-gradient(to right, var(--textBlack100), var(--colorBlueTk));\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin-bottom: 0 !important;\n}\n.scrollbar-hide {\n  scrollbar-width: none; \n  -ms-overflow-style: none;  \n}\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
